export default "__VITE_ASSET__DW3_9kBg__"